/* WAVE Hair Extensions - WhatsApp widget
   Self contained. No app, no external requests, no dependencies.
   Built 19 Aug 2026.

   ---------------------------------------------------------------
   EDIT THESE THREE LINES AND NOTHING ELSE
   --------------------------------------------------------------- */
(function () {
  var NUMBER   = '447853301241';   // international, no + and no spaces
  var DELAY_MS = 4000;             // wait before the bubble appears
  var NUDGE_MS = 9000;             // wait before the "Not sure which shade?" label shows
  /* --------------------------------------------------------------- */

  if (window.__waveWA) return;
  window.__waveWA = true;

  var GREEN = '#25D366';
  var INK   = '#111111';

  /* ---------- what the customer's first message says ----------

     IMPORTANT: the phrase "trade pricing" is what the GoHighLevel
     workflow matches on to auto tag the contact as a hairdresser.
     Do not reword that line without updating the workflow filter.

     TRADE pages this fires on (checked 19 Aug 2026):
       /pages/trade-application
       /pages/wholesale-hair-extensions
       /collections/wholesale

     Deliberately NOT matching the word "professional", because
     these are retail product collections, not trade pages:
       /collections/shop-all-professional-tools
       /collections/nano-bond-professional-tools
       /collections/tape-in-professional-tools
       /collections/weft-professional-tools
       /collections/pre-bonded-professional-tools
     ------------------------------------------------------------- */
  function tidy(t) {
    if (!t) return '';
    return t.replace(/\s*\|\s*100%\s*Remy/i, '')
            .replace(/\s*\|\s*WAVE.*$/i, '')
            .replace(/\s+/g, ' ')
            .trim();
  }

  function isTrade() {
    return /wholesale|trade|salon/.test(window.location.pathname);
  }

  function productName() {
    var h1 = document.querySelector('.t4s-product__info h1, h1.t4s-product__title, main h1, h1');
    var t  = h1 && h1.textContent ? h1.textContent : '';
    if (!t.trim()) {
      var og = document.querySelector('meta[property="og:title"]');
      t = og && og.content ? og.content : '';
    }
    return tidy(t);
  }

  function buildMessage() {
    var path = window.location.pathname;
    var name = productName();

    // trade first, so a hairdresser on a trade page never gets the shade match message
    if (isTrade()) {
      return 'Hi WAVE, I am a hairdresser and I would like to ask about trade pricing.';
    }
    if (path.indexOf('colour') > -1 || path.indexOf('color') > -1) {
      return 'Hi WAVE, I would like a colour match please. I can send a photo of my hair.';
    }
    if (path.indexOf('/products/') === 0 && name) {
      return 'Hi WAVE, I am looking at ' + name + ' and I would like help matching my shade.';
    }
    if (path.indexOf('/collections/') === 0) {
      return 'Hi WAVE, I would like help choosing the right shade and length.';
    }
    return 'Hi WAVE, I have a question about your hair extensions.';
  }

  function waLink() {
    return 'https://wa.me/' + NUMBER + '?text=' + encodeURIComponent(buildMessage());
  }

  /* ---------- styles ---------- */
  var css = ''
    + '#wave-wa{position:fixed;right:16px;z-index:9400;font-family:inherit;'
    + '  bottom:calc(20px + env(safe-area-inset-bottom,0px));'
    + '  display:flex;flex-direction:column;align-items:flex-end;gap:10px;'
    + '  opacity:0;transform:translateY(12px);transition:opacity .35s ease,transform .35s ease,bottom .25s ease;pointer-events:none}'
    + '#wave-wa.is-in{opacity:1;transform:none;pointer-events:auto}'
    /* WAVE, 19 September 2026. Two offsets on phones and tablets instead of
       one. Low in the corner by default, and lifted clear only while the
       sticky add to cart bar is actually on screen. The watchStickyBar
       function further down is what switches between them, and the comment
       above it explains why. */
    + '@media (max-width:1024px){#wave-wa{bottom:calc(20px + env(safe-area-inset-bottom,0px))}}'
    + '@media (max-width:1024px){#wave-wa.has-bar{bottom:calc(74px + env(safe-area-inset-bottom,0px))}}'

    + '#wave-wa-btn{width:56px;height:56px;border-radius:50%;border:0;cursor:pointer;'
    + '  background:' + GREEN + ';box-shadow:0 6px 20px rgba(0,0,0,.22);'
    + '  display:flex;align-items:center;justify-content:center;padding:0;'
    + '  transition:transform .18s ease,box-shadow .18s ease}'
    + '#wave-wa-btn:hover{transform:scale(1.06);box-shadow:0 8px 26px rgba(0,0,0,.28)}'
    + '#wave-wa-btn:focus-visible{outline:3px solid ' + INK + ';outline-offset:3px}'
    + '#wave-wa-btn svg{width:30px;height:30px;display:block}'

    + '#wave-wa-nudge{background:#fff;color:' + INK + ';border-radius:10px;padding:9px 14px;'
    + '  font-size:13px;line-height:1.35;font-weight:600;max-width:190px;text-align:right;'
    + '  box-shadow:0 4px 16px rgba(0,0,0,.14);cursor:pointer;'
    + '  opacity:0;transform:translateX(8px);transition:opacity .3s ease,transform .3s ease}'
    + '#wave-wa-nudge.is-in{opacity:1;transform:none}'
    + '#wave-wa.is-open #wave-wa-nudge{display:none}'

    + '#wave-wa-card{width:290px;background:#fff;border-radius:14px;overflow:hidden;'
    + '  box-shadow:0 14px 44px rgba(0,0,0,.24);display:none}'
    + '#wave-wa.is-open #wave-wa-card{display:block}'
    + '#wave-wa-head{background:' + INK + ';color:#fff;padding:14px 16px;position:relative}'
    + '#wave-wa-head strong{display:block;font-size:14px;letter-spacing:.04em;text-transform:uppercase}'
    + '#wave-wa-head span{display:block;font-size:12px;opacity:.72;margin-top:3px}'
    + '#wave-wa-x{position:absolute;top:10px;right:10px;background:none;border:0;color:#fff;'
    + '  font-size:20px;line-height:1;cursor:pointer;padding:4px 7px;opacity:.75}'
    + '#wave-wa-x:hover{opacity:1}'
    + '#wave-wa-body{padding:16px}'
    + '#wave-wa-body p{margin:0 0 14px;font-size:14px;line-height:1.5;color:#333}'
    + '#wave-wa-cta{display:flex;align-items:center;justify-content:center;gap:9px;'
    + '  background:' + GREEN + ';color:#fff;text-decoration:none;font-weight:700;font-size:14px;'
    + '  padding:12px 16px;border-radius:9px;transition:filter .15s ease}'
    + '#wave-wa-cta:hover{filter:brightness(.94);color:#fff}'
    + '#wave-wa-cta svg{width:18px;height:18px}'

    + '@media (prefers-reduced-motion:reduce){#wave-wa,#wave-wa-nudge,#wave-wa-btn{transition:none}}';

  var LOGO = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.08-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.65-2.05-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.01-1.04 2.46 0 1.45 1.06 2.85 1.21 3.05.15.2 2.09 3.19 5.07 4.47.71.31 1.26.49 1.69.63.71.23 1.36.19 1.87.12.57-.09 1.75-.72 2-1.41.25-.69.25-1.28.17-1.41-.07-.12-.27-.2-.57-.35z"/><path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.46 1.32 4.96L2 22l5.25-1.38a9.86 9.86 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2zm0 18.13h-.01a8.2 8.2 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.2 8.2 0 0 1-1.26-4.36c0-4.54 3.7-8.23 8.25-8.23 2.2 0 4.27.86 5.83 2.41a8.19 8.19 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23z"/></svg>';

  /* ---------- keeping clear of the sticky add to cart bar ----------

     WAVE, 19 September 2026.

     WHAT WAS WRONG
     On phones and tablets the button sat a fixed 74px up from the bottom of
     the screen. That number was not arbitrary: the theme's sticky add to cart
     bar is 60px tall and sits across the very bottom, so 74px kept the button
     just above it, with about 14px to spare. Measured on a 375 x 812 phone the
     button's lower edge landed at 750px and the bar's top edge at 752px.

     The trouble is that the bar is only on screen some of the time. For the
     rest of the visit the button floated well up the page, sitting over the
     content, and on a product page that is exactly where the shade swatches
     and the offer popup are. Daniel reported it on 19 September.

     WHAT HAPPENS NOW
     The button sits low in the corner, where a chat button belongs, and lifts
     itself out of the way only while the bar is genuinely on screen. It
     glides rather than jumps, because the wrapper now transitions its bottom
     value too.

     WHY THE BAR IS MEASURED RATHER THAN DETECTED BY CLASS NAME
     The theme hides the bar with a transform plus a couple of utility classes
     (t4s-op-0, t4s-pe-none). Those are theme internals and any Unsen update
     could rename them. A rectangle cannot be renamed, so this reads the bar's
     real position instead. If the bar is switched off, restyled or resized in
     the theme settings, this keeps working with no change.

     WHY IT IS NOT A ONE OFF CHECK
     The theme builds and toggles the bar after this script runs, so a single
     measurement on load would miss it. Scroll and resize cover it from then
     on, and a short burst of early checks covers the first few seconds. There
     is deliberately no MutationObserver on the document: watching the whole
     page for attribute changes would fire constantly on a busy product page
     for no benefit, since the bar only ever appears or disappears in response
     to a scroll. */
  function watchStickyBar(wrap) {
    var queued = false;

    function measure() {
      queued = false;
      var bar = document.querySelector('[data-sticky-addtocart]');
      var showing = false;
      if (bar) {
        var r = bar.getBoundingClientRect();
        /* On screen means it has a real height AND its top edge is above the
           bottom of the window. When the theme hides the bar it pushes it
           below that line, so this is true only when it is really visible. */
        showing = r.height > 0 && r.top < (window.innerHeight - 2);
      }
      wrap.classList.toggle('has-bar', showing);
    }

    function queue() {
      if (queued) return;
      queued = true;
      if (window.requestAnimationFrame) window.requestAnimationFrame(measure);
      else measure();
    }

    measure();
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });

    /* Ten checks over five seconds, then stop, to catch the bar being built
       after this runs. Scrolling keeps it correct from then on. */
    var tries = 0;
    var early = setInterval(function () {
      measure();
      if (++tries > 10) clearInterval(early);
    }, 500);
  }

  /* ---------- markup ---------- */
  function build() {
    var style = document.createElement('style');
    style.id = 'wave-wa-css';
    style.textContent = css;
    document.head.appendChild(style);

    var trade = isTrade();

    var wrap = document.createElement('div');
    wrap.id = 'wave-wa';
    wrap.innerHTML = ''
      + '<div id="wave-wa-card" role="dialog" aria-label="Chat to WAVE on WhatsApp">'
      +   '<div id="wave-wa-head">'
      +     '<strong>' + (trade ? 'Trade enquiry?' : 'Not sure which shade?') + '</strong>'
      +     '<span>' + (trade ? 'Talk to us directly' : 'We will match it for you') + '</span>'
      +     '<button id="wave-wa-x" type="button" aria-label="Close">&times;</button>'
      +   '</div>'
      +   '<div id="wave-wa-body">'
      +     '<p>' + (trade
              ? 'Message us on WhatsApp about trade pricing, minimum orders and how a WAVE wholesale account works. We will come back to you personally.'
              : 'Send us a photo of your hair on WhatsApp and a real person will tell you which shade to order. Free, and no obligation to buy.') + '</p>'
      +     '<a id="wave-wa-cta" href="#" target="_blank" rel="noopener">' + LOGO + ' Chat on WhatsApp</a>'
      +   '</div>'
      + '</div>'
      + '<div id="wave-wa-nudge" role="button" tabindex="0">' + (trade ? 'Trade enquiry? Message us &rarr;' : 'Not sure which shade? Ask us &rarr;') + '</div>'
      + '<button id="wave-wa-btn" type="button" aria-label="Chat to WAVE on WhatsApp" aria-expanded="false">' + LOGO + '</button>';
    document.body.appendChild(wrap);

    var btn   = wrap.querySelector('#wave-wa-btn');
    var close = wrap.querySelector('#wave-wa-x');
    var cta   = wrap.querySelector('#wave-wa-cta');
    var nudge = wrap.querySelector('#wave-wa-nudge');

    function open() {
      cta.href = waLink();
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      try { sessionStorage.setItem('waveWaSeen', '1'); } catch (e) {}
    }
    function shut() {
      wrap.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    }
    function toggle() { wrap.classList.contains('is-open') ? shut() : open(); }

    btn.addEventListener('click', toggle);
    close.addEventListener('click', function (e) { e.stopPropagation(); shut(); });
    nudge.addEventListener('click', open);
    nudge.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && wrap.classList.contains('is-open')) shut();
    });
    document.addEventListener('click', function (e) {
      if (wrap.classList.contains('is-open') && !wrap.contains(e.target)) shut();
    });
    cta.addEventListener('click', function () {
      var type = trade ? 'trade' : 'retail';
      if (window.dataLayer) window.dataLayer.push({ event: 'wave_whatsapp_click', page: window.location.pathname, enquiry_type: type });
      if (window.gtag) window.gtag('event', 'whatsapp_click', { page_path: window.location.pathname, enquiry_type: type });
    });

    setTimeout(function () { wrap.classList.add('is-in'); }, DELAY_MS);

    var seen = false;
    try { seen = sessionStorage.getItem('waveWaSeen') === '1'; } catch (e) {}
    if (!seen) {
      setTimeout(function () {
        if (!wrap.classList.contains('is-open')) nudge.classList.add('is-in');
      }, NUDGE_MS);
      setTimeout(function () { nudge.classList.remove('is-in'); }, NUDGE_MS + 8000);
    }

    watchStickyBar(wrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
